// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"RX","account_subscription_card_img":"SX","account_subscription_card_lower_section":"TX","account_subscription_card_category":"UX","account_subscription_card_title":"VX","account_subscription_card_price_section":"WX","account_subscription_card_servings":"XX","account_subscription_card_prices":"YX","account_subscription_card_price":"ZX","account_subscription_card_price_actual":"aY"};
    if(module.hot) {
      // 1713211526284
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  